import React from 'react';
import useHotmathsIcon from "@hooks/useHotmathsIcon";
import {Button} from "antd";

const IconActionButton = ({ iconName, muiIcon, onClick, children, ...other }) => {
    const hmIcon = iconName ? useHotmathsIcon(iconName) : null;

    return (
        <Button
            className={'ch-class-details-action-button'}
            onClick={onClick}
            {...other}
        >
            {hmIcon && hmIcon}
            {muiIcon && muiIcon}
            {children}
        </Button>
    );
};

export default IconActionButton;